import styles from './styles.module.scss';

interface Props {
    isThin?: boolean;
}

function Divider({ isThin }:Props) {
    return (<div aria-label='divider' className={isThin ? styles.thin : styles.normal} />);
}

export default Divider;
